import { LoaderPseudoelementCSS } from '@/components/atoms/BackgroundLoader/BackgroundLoader.styled';
import { medias } from '@/utils/sizes';
import styled from 'styled-components';

export const InfoResultsContainer = styled.div`
  display: grid;
  height: min-content;
  transition: opacity var(--tr-base);

  &[data-work-page-type='work'] {
    .initial-text {
      display: none;
    }
  }

  .initial-text {
    opacity: 0;
    transition: opacity var(--tr-base);
  }

  .results-text {
    opacity: 1; 
    transition: opacity var(--tr-base) 0.2s;
  }

  &[data-is-loading='true'] {

    .results-text {
      opacity: 0;
      transition: opacity var(--tr-fast);
    }

    .number {
      opacity: 0;
    }

    .loading-text {
      opacity: 1;
      transition: opacity var(--tr-fast) var(--tr-base);
    }

    .initial-text {
      opacity: 0;
      transition: opacity var(--tr-fast);
    }
  }

  p {
    flex-direction: row;
    grid-row-start: 1;
    grid-column-start: 1;

    span {
      display: contents;
    }
  }

  ${medias.max.mobile} {
    p {
      display: block;
    }
  }

  &[data-text-displayed='initial'] {
    .results-text {
      opacity: 0;
      transition: opacity var(--tr-fast);
    }

    .initial-text {
      opacity: 1;
      transition: opacity var(--tr-fast) var(--tr-base);
    }
  }

  &[data-text-displayed='none'] {
    .results-text {
      opacity: 0;
    }
    .initial-text {
      opacity: 0;
    }
  }

  &[data-is-loading='true'] {
    .loader {
      opacity: 1;
      transition: opacity var(--tr-base);
      ${LoaderPseudoelementCSS}
    }
  }
`;
